import { render } from "./configuration.vue?vue&type=template&id=2b9c1db5&scoped=true"
import script from "./configuration.vue?vue&type=script&lang=js"
export * from "./configuration.vue?vue&type=script&lang=js"

import "./configuration.vue?vue&type=style&index=0&id=2b9c1db5&scoped=true&lang=css"

import exportComponent from "/Users/abayomi/Documents/dev/microservice-2/contact-mgt-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9c1db5"]])

export default __exports__